// eslint-disable-next-line jira/filename-case
import { useCallback, useEffect, useState } from 'react';
import { registerEvent } from '@atlassian/server-to-client-comms/server-receiver';
import { getClientDispatcher } from '@atlassian/server-to-client-comms/client-dispatcher';
import type { SSRFailureProps } from '../types.tsx';

const SSR_EVENT = 'ssr-failure-display';

export type SSRFailureDisplays = Map<string, SSRFailureProps>;

export const pushSSRFailureDisplay = (failureProps: SSRFailureProps): void => {
	registerEvent({
		id: SSR_EVENT,
		name: 'onSSRFailureDisplay',
		args: [failureProps],
	});
};

export const useServerEventsSSRFailureDisplays = (): SSRFailureDisplays => {
	const [ssrFailureDisplays, setSSRFailureDisplays] = useState<SSRFailureDisplays>(new Map());
	const onSSRFailureDisplay = useCallback((failureProps: SSRFailureProps) => {
		setSSRFailureDisplays((prev) => {
			if (failureProps.fallbackId) {
				const newMap = new Map(prev);
				newMap.set(failureProps.fallbackId, failureProps);
				return newMap;
			}
			return prev;
		});
	}, []);
	useEffect(() => {
		getClientDispatcher().register(SSR_EVENT, onSSRFailureDisplay);
		return () => {
			getClientDispatcher().unregister(SSR_EVENT);
		};
	}, [onSSRFailureDisplay]);

	return ssrFailureDisplays;
};
